/**
 * Implementation of Step 2 ( region selection) of monitor creation
 * 
 * @author - Harsh Tomar
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import Switch from "../Switch";

const geoUrl =
  "https://raw.githubusercontent.com/zcreativelabs/react-simple-maps/master/topojson-maps/world-110m.json";

  const markers = [
    { markerOffset: 25, name: "Ohio (US)", coordinates: [-82.9071, 40.4173], selected: false },
    { markerOffset: -15, name: "Cape Town (Africa)", coordinates: [18.4241, -33.9249], selected: false },
    { markerOffset: -15, name: "Jakarta", coordinates: [106.8456, -6.2088], selected: false },
    { markerOffset: -15, name: "Mumbai (India)", coordinates: [72.8777, 19.0760], selected: false },
    { markerOffset: -15, name: "Sydney (Australia)", coordinates: [151.2093, -33.8688], selected: false },
    { markerOffset: -15, name: "Canada", coordinates: [-104.3468, 56.1304], selected: false },
    { markerOffset: -15, name: "London (UK)", coordinates: [0.1276, 51.5072], selected: false },
    { markerOffset: 25, name: "São Paulo (Brazil)", coordinates: [-46.6396, -23.5558], selected: false },
    { markerOffset: 25, name: "Bahrain", coordinates: [50.5577, 20.0667], selected: false },
  ];

export default function StepTwo() {
  const [allRegions, setAllRegions] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState<string[]>([]);

  useEffect(() => {
    if(allRegions) {
      setSelectedRegions(markers.map(marker => marker.name))
    } else {
      setSelectedRegions(selectedRegions => selectedRegions)
    }
  }, [allRegions])

  useEffect(() => {
    if(markers.every(marker => selectedRegions.includes(marker.name))) {
      setAllRegions(true)
    } else {
      setAllRegions(false)
    }
  }, [selectedRegions])

  function _renderMarkerDot(status: boolean) {
    switch(status) {
      case false:
        return <circle r={8} fill="darkgray" className="relative bg-gray-200 cursor-pointer" />   
      case true:
        return (
          <>
            <circle r={8} fill="rgb(5, 150, 105)" className="relative bg-gray-200 cursor-pointer" />
            <circle r={8} fill="rgb(5, 150, 105)" className="absolute cursor-pointer" />
          </>
        )
    }
  }

  function _handleRegionClick(name: string) {
    if(selectedRegions.includes(name)) {
      return setSelectedRegions(selectedRegions => selectedRegions.filter(region => region !== name))
    }

    setSelectedRegions(selectedRegions => [...selectedRegions, name])
  }

  return (
    <div>
      {/* <h1 className="text-lg mb-2 mt-2 text-gray-700">Select region from where you want to monitor</h1> */}

      <div className="flex justify-between">
        <p className="text-lg"> All Regions </p>
        <Switch enabled={allRegions} onChange={setAllRegions} />
      </div>
      {/* <br/> */}
      <p className="text-center text-gray-500">OR</p>
      {/* <br/> */}
      <p className="text-lg text-gray-700">Select manually from map</p>

      <div className="py-4">
      <ComposableMap projection="geoMercator" projectionConfig={{ scale: 100, center: [0, 30] }} height={350}>
          <Geographies geography={geoUrl} className="">
            {({ geographies }) =>{
              return geographies.filter(geo => geo.properties.CONTINENT !== "Antarctica")
                .map(geo => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                    default: {
                      fill: "#ccc",
                      outline: "none"
                    },
                    hover: {
                      fill: "#ccc",
                      outline: "none"
                    },
                    pressed: {
                      fill: "#E42",
                      outline: "none"
                    }
                  }}
                />
              ))
            }}
          </Geographies>
          {
            markers.map(marker => 
              <Marker key={marker.name} coordinates={marker.coordinates as [number, number]} onClick={() => _handleRegionClick(marker.name)}>
                {_renderMarkerDot(selectedRegions.includes(marker.name))}
                <text
                  textAnchor="middle"
                  y={marker.markerOffset}
                  style={{ fontSize: 14, fill: "#5D5A6D", cursor: 'pointer', userSelect: 'none' }}
                >
                  {marker.name}
                </text>
              </Marker>
            )
          }
      </ComposableMap>
      </div>

      <button className="btn-primary float-right mr-4 px-8 mt-4">
        Next&nbsp;&nbsp;<BsArrowRight className="icon"/>
      </button>
    </div>
  )
}